// CC(커리어 센터)에서 불러오는 결과표

import CCResult from '@components/acca/cc/result';

const CCResultPage = () => {
  return <CCResult />;
};

export default CCResultPage;
